import styled from 'styled-components';
import {GameTitleDefaultBox} from './game-title.default.box';

export const GameTitleCasino777Box = styled(GameTitleDefaultBox)`
  color: ${props => props.theme.colors.textContrast};
  ${({theme}) => theme.font.presets.bold};
  font-size: 1.5rem;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    font-size: 1.2rem;
  }
`
